"use strict";

class BaseError extends Error {
  constructor(name, message, type) {
    super();
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
    this.name = name;
    this.message = message;
    this.type = type || '';
  }
}
export default BaseError;
//# sourceMappingURL=baseError.js.map